import { appContent } from '@/mocks/home';

export default function SectionApp() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 mx-auto max-w-7xl">
        <div className="bg-gradient-to-br from-primary-500 via-primary-600 to-accent-600 rounded-2xl overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center lg:items-stretch">
            <div className="flex-1 p-8 md:p-12 lg:p-14 text-center lg:text-left">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/20 text-background-50 text-xs font-medium mb-5">
                <i className="ri-smartphone-line"></i>
                移动客户端
              </div>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-3">{appContent.title}</h2>
              <p className="text-background-50/80 text-sm md:text-base mb-6">{appContent.subtitle}</p>

              <ul className="space-y-2.5 mb-7 inline-block text-left">
                {appContent.features.map((f, i) => (
                  <li key={i} className="flex items-center gap-2.5 text-sm text-background-50/90">
                    <i className="ri-checkbox-circle-fill text-background-50/80"></i>
                    {f}
                  </li>
                ))}
              </ul>

              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <span className="px-5 py-2.5 bg-background-50 text-primary-600 font-medium rounded-full text-sm whitespace-nowrap cursor-pointer hover:bg-background-100 transition-colors duration-200">
                  <i className="ri-android-line mr-1.5"></i>Android 下载
                </span>
                <span className="px-5 py-2.5 bg-background-50/15 text-background-50 font-medium rounded-full text-sm whitespace-nowrap cursor-pointer hover:bg-background-50/25 transition-colors duration-200 border border-background-50/30">
                  <i className="ri-apple-line mr-1.5"></i>iOS 下载
                </span>
              </div>
              <p className="text-xs text-background-50/60 mt-4">{appContent.badgeDesc}</p>
            </div>

            <div className="flex-1 hidden lg:block relative">
              <div className="absolute inset-0">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20mockup%20displaying%20a%20movie%20streaming%20app%20interface%20with%20warm%20cinematic%20design%2C%20floating%20on%20a%20dark%20gradient%20background%2C%20film%20poster%20thumbnails%20on%20screen%2C%20elegant%20UI%20with%20warm%20amber%20and%20gold%20accents%2C%20modern%20minimal%20device%20mockup%20style%2C%20soft%20glow%20effect%2C%20professional%20product%20photography&width=600&height=500&seq=app-section-2026&orientation=portrait"
                  alt="爱看影院移动客户端界面展示"
                  className="w-full h-full object-cover object-right"
                  width="600"
                  height="500"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}